import { ERROR_CODES } from '../Services/checkout-critical-errors'

export enum StripeCheckoutErrorCode {
  // Stripe Element Initialization Errors
  STRIPE_LIB_INITIALIZATION_ERROR = 1,
  STRIPE_ADDRESS_ELEMENT_INITIALIZATION_ERROR = 1 << 1,
  STRIPE_PAYMENT_ELEMENT_INITIALIZATION_ERROR = 1 << 2,
  STRIPE_LINK_AUTHENTICATION_ELEMENT_INITIALIZATION_ERROR = 1 << 3,
  STRIPE_EXPRESS_CHECKOUT_ELEMENT_INITIALIZATION_ERROR = 1 << 4,

  // CF2 API Call Errors
  API_SESSION_INITIALIZATION_ERROR = 1 << 5,

  // The mount() promise chain rejected outright, so the elements were never reached.
  // Deliberately not API_SESSION_INITIALIZATION_ERROR: that code keys its own Honeybadger
  // fault (it no longer renders a banner, the checkout falls back to card-only elements),
  // so reusing it would bury this separate failure inside the metric that fault measures.
  MOUNT_REJECTED_ERROR = 1 << 6,
}

export function getStripeCheckoutErrorMessage(stripeErrors: StripeCheckoutErrorCode[]): string | null {
  if (stripeErrors.length > 0) {
    const errorCodeMask = `0x${Number(stripeErrors.reduce((acc, val) => acc | val, 0)).toString(16)}`

    return 'Error initializing Checkout Element. Code: ' + errorCodeMask
  }
}

export function getInitialStripeCheckoutErrors(): { code: string }[] {
  const initialCriticalErrors = []
  if (!globalThis.globalResourceData.productVariantWithNoBump?.id) {
    initialCriticalErrors.push({ code: ERROR_CODES.EMPTY_PRODUCTS_ERROR })
  }
  return initialCriticalErrors
}
